import {metadata} from '../../libraries/metadata/metadata.js';
metadata.register("ooloAnalyticsAdapter", {"disclosures":{},"components":[{"componentType":"analytics","componentName":"oolo"}]})